const { h, render, Component } = require('preact');

class SignInSignUpBannerView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="sign-in-sign-up" data-bhw="web2018_sign_in_sign_up_banner">
        <div class="help-text">
          {this.props.getHelpText()}
        </div>
        <div class="buttons">
          <a target="_top" href={this.props.getSignInUrl()} class="sign_in_sign_up_button" data-bhw="web2018_sign_in_sign_up">
            {I18n.translate("js.modules.web_2018.sign_in_sign_up")}
          </a>
          <a href={this.props.getGuestCheckoutURL()} class="guest_checkout_button" data-bhw="web2018_guest_checkout">
            {I18n.translate("js.modules.web_2018.guest_checkout")}
          </a>
        </div>
      </div>
    );
  }
}
module.exports = SignInSignUpBannerView
